import React from "react";
import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Typography,
} from "@mui/material";
import { T } from "../components/T";

export const AreYouSureModal = ({
  title,
  question,
  confirm,
  onConfirm,
  open,
  setOpen,
}: {
  title: React.JSX.Element;
  question: React.JSX.Element;
  confirm: React.JSX.Element;
  onConfirm: () => void;
  open: boolean;
  setOpen: (open: boolean) => void;
}) => {
  return (
    <Dialog open={open} onClose={() => setOpen(false)}>
      <DialogTitle>{title}</DialogTitle>
      <DialogContent>
        <Typography variant="body1">{question}</Typography>
      </DialogContent>
      <DialogActions>
        <Button
          onClick={() => setOpen(false)}
          color="secondary"
          variant="outlined"
        >
          <T str="Cancel" />
        </Button>
        <Button onClick={onConfirm} color="error" variant="contained">
          {confirm}
        </Button>
      </DialogActions>
    </Dialog>
  );
};
